import React, { PureComponent } from 'react';
import {
  Nav,
  NavItem,
  Breadcrumb,
  BreadcrumbItem,
  Button,
  Col,
  Container,
  Row
} from 'reactstrap';
import { connect } from 'react-redux';
import { Route } from 'react-router';
import { Link } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import URI from 'urijs';
import { omit } from 'underscore';
import cx from 'classnames';
import Lightbox from 'react-images';

// modules
import BS from '../../theme/Bootstrap';
import styles from '../Containers.module.scss';
import cmpStyle from '../../components/Components.module.scss';

// ducks
import { fetch } from '../../ducks/CommunitySearch';

// components
import LoadError from '../../components/load-error/load-error';
import ResponsiveCarousel from '../../components/carousel/carousel';

// containers
import PropertySearch from '../PropertySearch/PropertySearch';
import PropertyDetailMap from '../PropertyDetail/PropertyDetailMap';

import notfound from '../PropertySearch/images/notfound.png';
const PHOTO_BASE_URL = '//communityphotos.naplesarea.com/';

const PROPERTY_SEARCH_TITLES = {
  residential: 'Homes For Sale in ',
  residential_income: 'Homes For Sale in ',
  commercial: 'Commercial Properties within 1 Mile Radius of ',
  rental: 'Rentals in ',
  land: 'Lot & Land in '
};

class CommunityDetail extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      activeImage: undefined,
      showMap: false
    };
  }

  render() {
    const { error, id, record, searchURI, detailURI, isLoading, loaded, propertyClass } =
      this.props;
    const isLoaded = !isLoading && loaded === id;

    return (
      <Container className={cx(cmpStyle.detail, styles.CommunityDetail)}>
        <Row>
          <Breadcrumb>
            <LinkContainer exact to="/">
              <BreadcrumbItem>
                <Link to="/">Home</Link>
              </BreadcrumbItem>
            </LinkContainer>
            <LinkContainer exact to="/find-community">
              <BreadcrumbItem>
                <Link to="/find-community">Community Search</Link>
              </BreadcrumbItem>
            </LinkContainer>
            <LinkContainer exact to={`/community/${id}`}>
              <BreadcrumbItem>
                <Link to={`/community/${id}`}>{id ? id.replace(/(-)/g, ' ') : id}</Link>
              </BreadcrumbItem>
            </LinkContainer>
          </Breadcrumb>
        </Row>
        <Route
          path="/community/:id"
          render={() => (
            <Container className={`${BS.breadcrumb2}`}>
              <Row>
                <Nav horizontal="space-between" className={`${BS.mt0} ${BS.mb3}`}>
                  {searchURI && !detailURI && (
                    <NavItem>
                      <Button color="link" tag={Link} to={searchURI}>
                        &lt; Back
                      </Button>
                    </NavItem>
                  )}
                  {detailURI && (
                    <NavItem>
                      <Button color="link" tag={Link} to={detailURI}>
                        &lt; Back
                      </Button>
                    </NavItem>
                  )}
                </Nav>
              </Row>
            </Container>
          )}
        />
        {isLoading && <div className={BS.loadingMask}>Loading</div>}
        {error && <LoadError error={error} retry={() => this.reload()} />}
        {isLoaded && (
          <div className={cmpStyle.header}>
            <h4>{record.get('name')}</h4>
          </div>
        )}
        {isLoaded && <div className={cmpStyle.details}>{this.renderCarousel()}</div>}
        {isLoaded && (
          <Row className={cx(cmpStyle.details, BS.gutters1)}>
            <Col xs={12} sm={4}>
              <div className={`${BS.p1}`}>
                <h5>Description</h5>
              </div>
            </Col>
            <Col xs={12} sm={8}>
              <p
                dangerouslySetInnerHTML={{
                  __html:
                    record.get('description') ||
                    "We are currently in the process of updating our firm's profile. Should you like to contact us, please use our contact information at the left and we will be happy to assist you with your real estate needs."
                }}
              />
            </Col>
          </Row>
        )}

        {isLoaded && !error && (
          <React.Fragment>
            <hr />
            <h5 className={BS.p1}>
              {PROPERTY_SEARCH_TITLES[propertyClass]}
              {record.get('name')}
            </h5>
            <Row className={cx(cmpStyle.details, BS.flex1)}>
              <PropertySearch
                communityName={record.get('name')}
                communityId={record.get('id')}
                hideBreadcrumb
                pathname={`/community/${id}`}
                pathnameAdvanced={`/community/${id}/advanced`}
                pathnameAdvancedResults={`/community/${id}/advanced/results`}
              />
            </Row>
          </React.Fragment>
        )}
      </Container>
    );
  }

  renderCarousel() {
    const {
      record: { photos },
      record
    } = this.props;
    const { activeImage } = this.state;
    const lat = parseFloat(record.get('latitude'), 10),
      lng = parseFloat(record.get('longitude'), 10);

    var children = (
      lat && lng
        ? [
            <div className={cmpStyle.map} key={0}>
              <PropertyDetailMap record={record} />
            </div>
          ]
        : []
    ).concat(
      photos.toJS().map((photo, i) => {
        return (
          <img
            key={i + 1}
            className={cx(cmpStyle.image, BS.h100)}
            src={`${PHOTO_BASE_URL}${photo.filename}`}
            alt={photo.filename}
            onClick={() => {
              this.showImageGalleryModal({ index: i });
            }}
            onError={e => {
              e.target.src = notfound;
            }}
          />
        );
      })
    );

    if (photos.size === 0) {
      children.push(
        <img
          key={children.length}
          src={notfound}
          alt="Not Found"
          className={cx(BS.imgFluid, BS.w100)}
        />
      );
    }

    return (
      <React.Fragment>
        <ResponsiveCarousel
          className={cmpStyle.gallery}
          key="carousel"
          xsNumPerPage={1}
          mdNumPerPage={6}
          xsActiveIndex={lat && lng ? 1 : 0}
          placeholderImg={notfound}
          xsClassName={BS.col12}
          mdClassName={`${BS.col12} ${BS.colSm6} ${BS.colMd4}`}
          keyboard={activeImage === undefined}
          paused={!!activeImage}
          printNumPerPage={6}
          printClassName={`${BS.col12} ${BS.colSm6} ${BS.colMd4}`}
          itemClassName={cmpStyle.galleryItem}
        >
          {children}
        </ResponsiveCarousel>
        {activeImage !== undefined && this.renderImageGalleryModal()}
      </React.Fragment>
    );
  }

  renderImageGalleryModal() {
    const { activeImage } = this.state;
    const {
      record: { photos }
    } = this.props;
    return (
      <Lightbox
        key="lightbox"
        isOpen
        currentImage={activeImage}
        backdropClosesModal
        images={photos.toJS().map(photo => {
          return {
            src: PHOTO_BASE_URL + photo.filename,
            caption: photo.photoFilename
          };
        })}
        onClickNext={() => {
          this.showImageGalleryModal({ index: activeImage + 1 });
        }}
        onClickPrev={() => {
          this.showImageGalleryModal({ index: activeImage - 1 });
        }}
        onClose={() => {
          this.hideImageGalleryModal();
        }}
      />
    );
  }

  showImageGalleryModal({ index }) {
    this.setState({
      activeImage: index
    });
  }

  hideImageGalleryModal() {
    this.setState({
      activeImage: undefined
    });
  }

  componentWillMount() {
    this.checkAndLoad();
  }

  componentDidUpdate() {
    this.checkAndLoad();
  }

  checkAndLoad() {
    const { loaded, isLoading, error, load, id } = this.props;
    if ((!loaded || loaded !== id) && !isLoading && (!error || loaded !== id)) {
      load({ id });
    }
  }

  reload() {
    const { load, id } = this.props;

    if (load && id) {
      load({ id });
    }
  }
}

export default connect(
  (state, props) => {
    const id = props.match.params.id;
    const { searchURI, detailURI } = URI(state.routing.location.search).search(true);
    const { pathname, search = {} } = state.routing.location;
    const query = URI(search).search(true);

    return {
      id,
      record: state.CommunitySearch.getIn(['detail', 'record']),
      isLoading: state.CommunitySearch.getIn(['detail', 'loading']),
      loaded: state.CommunitySearch.getIn(['detail', 'loaded']),
      error: state.CommunitySearch.getIn(['detail', 'error']),
      // These additional URIjs methods are being called to santitize the URL
      searchURI: searchURI
        ? URI(searchURI).protocol('').hostname('').port('').normalizePathname().toString()
        : '/find-community',
      detailURI:
        detailURI &&
        URI(detailURI).protocol('').hostname('').port('').normalizePathname().toString(),
      currentURI:
        pathname &&
        URI(pathname).search(omit(query, 'detailURI', 'searchURI')).toString(),
      propertyClass: query.propertyClass || 'residential'
    };
  },
  { load: fetch }
)(CommunityDetail);



// WEBPACK FOOTER //
// ./src/containers/CommunityDetail/CommunityDetail.js